<template>
  <v-flex>
    <template v-for="(variant, index) in product.variants">
      <v-select
        v-if="variant.options.length > 1"
        :key="index"
        :items="formatOptions(variant)"
        v-model="selections[variant.name]"
        :label="variant.name"
        item-text="text"
        return-object
        @change="select"
      />

      <div
        v-else
        :key="index"
        class="py-3 subheading grey--text"
      >{{ variant.name }}: {{ selections[variant.name] }}</div>
    </template>
  </v-flex>
</template>

<script>
export default {
  name: 'OrderDraftItemVariants',

  props: {
    product: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      selections: {}
    }
  },

  beforeMount () {
    const comparator = (a, b) => (a.options.length > b.options.length) ? -1 : ((b.options.length > a.options.length) ? 1 : 0)

    this.product.variants.sort(comparator).forEach(variant => {
      this.selections[variant.name] = variant.options.length === 1 ? variant.options[0] : null
    })
  },

  methods: {
    select (val) {
      if (typeof val !== 'object') {
        return
      }

      this.selections[val.name] = val.value

      if (Object.keys(this.selections).length !== this.product.variants.length) {
        return
      }

      let product = this.product.children.find(child => {
        if (!child.properties) {
          return false
        }

        for (let [name, value] of Object.entries(this.selections)) {
          let has = child.properties.findIndex(item => {
            return item.name === name && item.value === value
          })

          if (has === -1) {
            return false
          }
        }

        return true
      })

      if (product) {
        this.$emit('selected', product)
      }
    },

    formatOptions (variant) {
      return variant.options.map(option => {
        return {
          name: variant.name,
          text: option,
          value: option
        }
      })
    }
  }
}
</script>
